export function objectDeepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (typeof globalThis.structuredClone === 'function') {
        try {
            return globalThis.structuredClone(obj);
        }
        catch {
            console.warn('structuredClone failed, falling back to deepClonePruningNonStructured', obj);
        }
    }
    else {
        try {
            return JSON.parse(JSON.stringify(obj));
        }
        catch (error) {
            console.warn('Deep clone failed using JSON fallback.', error);
        }
    }
    return deepClonePruningNonStructured(obj);
}
function deepClonePruningNonStructured(value, seen = new WeakMap()) {
    if (value === null) {
        return null;
    }
    const valueType = typeof value;
    if (valueType !== 'object') {
        if (valueType === 'function' || valueType === 'symbol' || valueType === 'bigint') {
            return undefined;
        }
        if (valueType === 'number' && !Number.isFinite(value)) {
            return null;
        }
        return value;
    }
    const obj = value;
    const existing = seen.get(obj);
    if (existing) {
        return existing;
    }
    if (Array.isArray(obj)) {
        const clonedArray = new Array(obj.length);
        seen.set(obj, clonedArray);
        for (let index = 0; index < clonedArray.length; index += 1) {
            const clonedItem = deepClonePruningNonStructured(obj[index], seen);
            clonedArray[index] = clonedItem === undefined ? null : clonedItem;
        }
        return clonedArray;
    }
    const proto = Object.getPrototypeOf(obj);
    if (proto !== Object.prototype && proto !== null) {
        return undefined;
    }
    const clonedObject = {};
    seen.set(obj, clonedObject);
    for (const [key, val] of Object.entries(obj)) {
        const clonedVal = deepClonePruningNonStructured(val, seen);
        if (clonedVal !== undefined) {
            clonedObject[key] = clonedVal;
        }
    }
    return clonedObject;
}
//# sourceMappingURL=obj-clone.js.map